import "./JobsBoardIndexRail.css";
import Avatar from "../../../../components/base/Avatar";


export interface IndexRailItem {
    id?: string
    name?: string
    count?: number
    /** The tab's colour (status, metro). */
    color?: string
    /** Person groups (technician) show the avatar inside the tab. */
    avatarUrl?: string
}

// What fills the square tab: "color" a plain colour (status), "colorLetter" the colour plus the
// first letter (metro -- many metros share a colour), "avatar" a technician's face, "letter" the
// group's first letter on grey, like a dictionary's letter tabs (type, source).
export type IndexRailMode = "color" | "colorLetter" | "avatar" | "letter"

interface IProps {
    mode: IndexRailMode
    groups: IndexRailItem[]
    active: number
    onPick: (index: number) => void
}

// Thumb index down the board's left edge, like the tabs cut into a dictionary: one square tab
// per group, half tucked behind the edge; the current group's tab sticks fully out and a click
// jumps to that group.
export default function JobsBoardIndexRail(props: IProps) {

    return (
        <div className={`board-index-rail board-index-${props.mode}`}>
            {
                props.groups.map((g, i) => (
                    // Keyed by position: group ids can repeat (a type grouped by id + name, or every
                    // "none" group without one), and duplicate keys make React leave old tabs behind.
                    <a key={`board-index-${i}`} href="#"
                        className={`board-index-tab${i == props.active ? " active" : ""}`}
                        style={{ ["--tab-color" as any]: g.color ?? "var(--bs-gray-400)" }}
                        aria-label={`Go to ${g.name}`}
                        onClick={e => {
                            e.preventDefault()
                            props.onPick(i)
                        }}>
                        <span className="board-index-tab-clip">
                            <span className="board-index-tab-square">
                                {
                                    props.mode == "avatar" ?
                                        <Avatar avatarUrl={g.avatarUrl} fullName={g.name ?? "?"} width={28} textSize={12} type="square" />
                                        : props.mode == "letter" || props.mode == "colorLetter" ?
                                            (g.name ?? "-").trim().charAt(0).toUpperCase()
                                            : null
                                }
                            </span>
                        </span>
                        <span className="board-index-tab-label">
                            {g.name ?? "-"}
                            <span className="board-index-tab-count">{g.count}</span>
                        </span>
                    </a>
                ))
            }
        </div>
    )
}
